import { useSnackbar as useNotistackSnackbar } from "notistack";
import type { OptionsObject } from "notistack";
import type { ReactNode } from "react";

type OpenSnackbar = (message: string | ReactNode, duration?: number) => void;
type CloseSnackbar = () => void;

export function useSnackbar(
  options: OptionsObject = {}
): [OpenSnackbar, CloseSnackbar] {
  const { enqueueSnackbar, closeSnackbar } = useNotistackSnackbar();

  const open: OpenSnackbar = (message, duration) => {
    enqueueSnackbar(message, {
      ...options,
      ...(duration !== undefined ? { autoHideDuration: duration } : {}),
    });
  };

  const close: CloseSnackbar = () => closeSnackbar();

  return [open, close];
}
